<template>
  <el-dialog
    :modal-append-to-body="false"
    :append-to-body="true"
    title="賬目痕跡"
    :visible.sync="dialogVisible"
    width="800px"
  >
    <el-table :data="tableData" style="width: 100%;color: black;">
      <template v-for="col in column">
        <el-table-column
          :key="col.model"
          align="center"
          :label="col.label"
          :prop="col.model"
        >
          <template slot-scope="scope">
            <template v-if="col.model === 'nameEnglish'">
              <div style="word-break:normal;">
                {{ scope.row[col.model] }}
              </div>
            </template>
            <template v-else>
              {{ scope.row[col.model] }}
            </template>
          </template>
        </el-table-column>
      </template>
    </el-table>
    <el-pagination
      style="text-align: center;margin-top: 20px;"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="total, sizes, prev, pager, next"
    >
    </el-pagination>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      billId: "",
      size: 10,
      currentPage: 1,
      total: 100,
      tableData: [{}, {}],
      column: [
        { model: "billId", label: "流水號" },
        { model: "nameEnglish", label: this.$t("app.nameEnglish") },
        { model: "nameChina", label: this.$t("app.nameChina") },
        { model: "studentNumber", label: this.$t("app.studentNumber") },
        {
          model: "type",
          label: "費用類型"
        },
        {
          model: "total",
          label: "總費用"
        },
        {
          model: "status",
          label: "交費狀態"
        }
      ]
    };
  },
  methods: {
    visit(billId) {
      this.billId = billId;
      this.dialogVisible = true;
    }
  }
};
</script>
